export default "__VITE_ASSET__DcRUHboM__"